"use strict";

import Vue from 'vue';
import axios from "axios";

// Configuración básica de axios
let config = {
  // Puedes agregar la base URL si es necesario
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
};

const _axios = axios.create(config);

// El token también en el axios global: hay ficheros que hacen `import axios from 'axios'`
// directamente (sin pasar por _axios) y, como la API exige sesión, daban 401.
axios.interceptors.request.use(function(config) {
  const token = localStorage.getItem('access_token');
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Aviso a pantalla completa cuando la API está en mantenimiento (responde 503)
function mostrarMantenimiento() {
  if (document.getElementById('aviso-mantenimiento')) return;
  const aviso = document.createElement('div');
  aviso.id = 'aviso-mantenimiento';
  aviso.style.cssText = 'position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center;background:rgba(244,246,248,.97);font-family:inherit;';
  aviso.innerHTML = '<div style="max-width:440px;padding:40px 32px;text-align:center;background:#fff;border-radius:12px;box-shadow:0 2px 12px rgba(0,0,0,.08)">'
    + '<h2 style="font-size:22px;margin:0 0 12px">Estamos mejorando 4Drive</h2>'
    + '<p style="margin:0 0 20px;color:#52606d;line-height:1.5">El sistema está en mantenimiento durante unos minutos. Vuelve a intentarlo en un rato.</p>'
    + '<button type="button" onclick="location.reload()" style="padding:10px 20px;border:0;border-radius:8px;background:#1f2933;color:#fff;cursor:pointer">Reintentar</button>'
    + '</div>';
  document.body.appendChild(aviso);
}

// Interceptor de solicitud para agregar el token
_axios.interceptors.request.use(
  function(config) {
    // Obtener el token del localStorage
    const token = localStorage.getItem('access_token');

    // Si el token existe, agregarlo a los headers de la solicitud
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Continuar con la solicitud
    return config;
  },
  function(error) {
    // Manejar el error en la solicitud
    return Promise.reject(error);
  }
);

// Interceptor de respuesta
_axios.interceptors.response.use(
  function(response) {
    // Manejar la respuesta exitosa
    return response;
  },
  function(error) {
    // Manejar errores, como token inválido o expirado
    if (error.response && error.response.status === 401) {
      // Eliminar el token si es necesario
      localStorage.removeItem('access_token');
      localStorage.removeItem('user');
      // Redirigir al usuario al login si el token es inválido o ha expirado
      window.location.href = '/';
    }

    if (error.response && error.response.status === 503) {
      mostrarMantenimiento();
    }

    // Propagar el error si es otro tipo de error
    return Promise.reject(error);
  }
);

Plugin.install = function(Vue, options) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    },
  });
};

Vue.use(Plugin);

export default Plugin;
